export default {
  exchange: 'exchange',
  inbox: 'inbox',
  threads: 'threads',
  notifications: 'notifications',
  reviews: 'reviews',
  sql: 'sql',
  editProfile: 'editProfile',
  init: 'init',
  graphQL: 'graphql',
  user: 'user',
  reservation: 'reservation',
  hooks: 'hooks',
};



// WEBPACK FOOTER //
// ./src/logGroups.js